document.addEventListener('DOMContentLoaded', () => {
  const list = document.querySelector('.drawer__product-list');
  const bar  = document.querySelector('.drawer__swipe-bar');
  if (!list || !bar) return;

  const update = () => {
    const max = list.scrollWidth - list.clientWidth;
    const pct = max ? list.scrollLeft / max : 0;
    bar.style.transform = `scaleX(${pct})`;
  };

  list.addEventListener('scroll', update, {passive:true});
  update();                 // init bij openen
});
